import React, { useEffect, useRef, useState } from 'react'
import {
  Router,
  Route,
  Switch,
  Link,
  useHistory,
  useLocation,
  Redirect,
} from 'react-router-dom'
import * as constants from '../../constants/constants'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'

import { Layout, Col, Row, Menu, message } from 'antd'

import collegeManageStyles from './college-oam.module.less'

import memberIcon from '../../static/image/college-oam/memberIcon.png'
import courseIcon from '../../static/image/college-oam/courseIcon.png'
import collegeNumberIcon from '../../static/image/college-oam/collegeNumberIcon.png'
import { BankOutlined, FieldTimeOutlined } from '@ant-design/icons'

import CollegeCourseList from './college-course-list'
import CollegeMemberList from './college-member-list'
import CollegeClusterManager from './college-cluster-manager'
import CollegeClusterDetail from './college-cluster-detail'
import ProjectCollegeNumber from './project-college-number'
import CollegeClassRoomList from './college-classroom-list'
import CollegeClassRoomDetail from './college-classroom-detail'
import CollegeCommitRecord from './college-commit-record'
import CollegeCommitDetail from './college-commit-detail'
import CollegeLoginRecords from './college-login-records'

import UserInfo, { checkUserLogin } from '../common/user-center/user-info'
export interface Props {
  match: any
}

const CollegeAdmin: React.FC<Props> = (props) => {
  console.log('props', props)
  const [selectedTabKey, setSelectedTabKey] = useState(['teastu_manage'] as any) //选中的项目菜单项
  const [collegeInfo, setCollegeInfo] = useState(null as any) // 当前院校信息
  const [collegeId, setCollegeId] = useState(null as any) // 当前用户是否为当前院校管理员
  const [isLogin, setIsLogin] = useState(false) //是否登录
  const [isCollegeManager, setIsCollegeManager] = useState(null as any) // 当前用户是否为当前院校管理员

  const [studentCode, setStudentCode] = useState('') //机构学生码
  const [studentCodeTime, setStudentCodeTime] = useState('') //机构学生码有效期

  const [teacherCode, setTeacherCode] = useState('') //机构教师码
  const [teacherCodeTime, setTeacherCodeTime] = useState('') //机构教师码有效期

  const history = useHistory()

  const location = useLocation()

  const institutionCallback = (response: any) => {
    // console.log(response);
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/login?next=/college-oam'
    } else if (response.is_ok == true) {
      // 成功

      setCollegeInfo(response.college_info)
      setStudentCode(response.college_info.student_code)
      setStudentCodeTime(response.college_info.student_code_time)

      setTeacherCode(response.college_info.teacher_code)
      setTeacherCodeTime(response.college_info.teacher_code_time)
    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/login?next=/college-oam'
    } else {
      message.error(response.message)
    }
  }

  // 查询课程信息
  const queryInstitution = (collegeId: any) => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      college_id: collegeId,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'college/api/manager_query_college_by_id/',
      queryData,
      institutionCallback
    )
  }

  useEffect(() => {
    location.pathname.split('/')[2] == 'classroom_detail'
      ? setSelectedTabKey(['class_manage'])
      : location.pathname.split('/')[2] == 'commit_detail'
      ? setSelectedTabKey(['commit_record'])
      : location.pathname.split('/')[2] == 'cluster_detail'
      ? setSelectedTabKey(['cluster_manage'])
      : setSelectedTabKey(location.pathname.split('/')[2])
  }, [location])

  useEffect(() => {
    //首先做权限验证，验证当前用户是否为当前院校管理员
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
          if (response?.college_info?.college_id !== '') {
            //已加入机构
            let _collegeId = response.college_info.college_id

            console.log(props.match.url.split('/'))
            setCollegeId(_collegeId)

            setIsCollegeManager(
              response.college_info.is_manager == 1 ? true : false
            )
            if (response.college_info.is_manager == 1) {
              queryInstitution(_collegeId)
            } else {
              window.location.href = '/user-center'
            }
          } else {
            //未加入机构
            setCollegeId(0)
            window.location.href = '/user-center'
          }
        } else {
          //用户未登录
          setIsLogin(false)
        }
      }
    )
  }, [])

  const handleClick = (e: any) => {
    setSelectedTabKey(e.key)
    e.key == 'teastu_manage'
      ? history.push(`${props.match.path}/teastu_manage/${collegeId}`)
      : e.key == 'project_manage'
      ? history.push(`${props.match.path}/project_manage/${collegeId}`)
      : e.key == 'class_manage'
      ? history.push(`${props.match.path}/class_manage`)
      : e.key == 'college_code'
      ? history.push(`${props.match.path}/college_code/${collegeId}`)
      : e.key == 'login_records'
      ? history.push(`${props.match.path}/login_records`)
      : e.key == 'cluster_manage'
      ? history.push(`${props.match.path}/cluster_manage`)
      : e.key == 'commit_record'
      ? history.push(`${props.match.path}/commit_record`)
      : history.push(`${props.match.path}`)
  }

  return (
    <Layout style={{ backgroundColor: '#f2f2f2' }}>
      <Row
        wrap={false}
        style={{ backgroundColor: '#f2f2f2' }}
        className={collegeManageStyles.projectMain}
      >
        <Col
          flex="250px"
          className={collegeManageStyles.sidebarCol}
        >
          <div className={collegeManageStyles.projectMenuWrapper}>
            <Menu
              style={{ marginTop: 20 }}
              mode="inline"
              defaultSelectedKeys={['teastu_manage']}
              selectedKeys={selectedTabKey}
              onClick={handleClick}
            >
              <div
                onClick={() => {
                  window.open('/')
                }}
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  padding: '10px 10px',
                  borderBottom: '1px solid rgba(2, 83, 147, 0.1)',
                }}
              >
                <img
                  height="40px"
                  width="200px"
                  src={constants.BACKEND_API_URL + collegeInfo?.logo_url}
                />
              </div>

              <Menu.Item key="teastu_manage">
                <Link to={`${props.match.path}/teastu_manage/${collegeId}`}>
                  {' '}
                  <img
                    src={memberIcon}
                    alt=""
                    className={collegeManageStyles.icon}
                  />
                  师生管理
                </Link>
              </Menu.Item>

              <Menu.Item key="project_manage">
                <Link to={`${props.match.path}/project_manage/${collegeId}`}>
                  <img
                    src={courseIcon}
                    alt=""
                    className={collegeManageStyles.icon}
                  />
                  项目管理
                </Link>
              </Menu.Item>

              <Menu.Item
                key="class_manage"
                icon={
                  <BankOutlined
                    style={{ marginRight: 8 }}
                    className={collegeManageStyles.icon}
                  />
                }
              >
                <Link to={`${props.match.path}/class_manage`}>班级管理</Link>
              </Menu.Item>

              <Menu.Item key="college_code">
                <Link to={`${props.match.path}/college_code/${collegeId}`}>
                  <img
                    src={collegeNumberIcon}
                    alt=""
                    style={{ width: 14, height: 16, marginLeft: 2 }}
                    className={collegeManageStyles.icon}
                  />
                  院校码
                </Link>
              </Menu.Item>

              <Menu.Item
                key="login_records"
                icon={
                  <FieldTimeOutlined
                    style={{ marginRight: 8 }}
                    className={collegeManageStyles.icon}
                  />
                }
              >
                <Link to={`${props.match.path}/login_records`}>登录动态</Link>
              </Menu.Item>

              {/* <Menu.Item key="cluster_manage">
                <Link to={`${props.match.path}/cluster_manage`}>
                  <i
                    className="iconfont icon-supervision"
                    style={{ marginRight: 15 }}
                  ></i>
                  集群监控
                </Link>
              </Menu.Item>

              <Menu.Item key="commit_record">
                <Link to={`${props.match.path}/commit_record`}>
                  <i
                    className="iconfont icon-wodetijiaojilu"
                    style={{ marginRight: 15 }}
                  ></i>
                  提交记录
                </Link>
              </Menu.Item> */}
            </Menu>
          </div>
        </Col>

        <Col
          flex="auto"
          className={collegeManageStyles.contentCol}
        >
          <div className={collegeManageStyles.topBar}>
            <Row wrap={false} align="middle">
              <Col flex="auto" className={collegeManageStyles.topBarTitle}>
                数据科学和人工智能综合项目实验平台
              </Col>
              <Col flex="none" style={{ paddingRight: 20 }}>
                {' '}
                <UserInfo />
              </Col>
            </Row>
          </div>
          {
            <div>
              <Switch>
                <Route
                  path={`${props.match.path}/teastu_manage/:college_id`}
                  exact
                  component={CollegeMemberList}
                ></Route>
                <Route
                  path={`${props.match.path}/project_manage/:college_id`}
                  exact
                  component={CollegeCourseList}
                ></Route>
                <Route
                  path={`${props.match.path}/class_manage`}
                  component={CollegeClassRoomList}
                ></Route>
                <Route
                  path={`${props.match.path}/college_code/:college_id`}
                  exact
                  component={ProjectCollegeNumber}
                ></Route>
                <Route
                  path={`${props.match.path}/login_records`}
                  exact
                  component={CollegeLoginRecords}
                ></Route>
                <Route
                  path={`${props.match.path}/cluster_manage`}
                  exact
                  render={() => <CollegeClusterManager />}
                ></Route>
                <Route
                  path={`${props.match.path}/cluster_detail`}
                  exact
                  render={() => <CollegeClusterDetail />}
                ></Route>
                <Route
                  path={`${props.match.path}/commit_record`}
                  exact
                  component={CollegeCommitRecord}
                ></Route>
                <Route
                  path={`${props.match.path}/commit_detail`}
                  exact
                  component={CollegeCommitDetail}
                ></Route>
                <Route
                  path={`${props.match.path}/classroom_detail/:classroom_id`}
                  exact
                  component={CollegeClassRoomDetail}
                ></Route>
                {collegeId && (
                  <Redirect
                    from={`${props.match.path}`}
                    to={`${props.match.path}/teastu_manage/${collegeId}`}
                  />
                )}
              </Switch>
            </div>
          }
        </Col>
      </Row>
    </Layout>
  )
}

export default CollegeAdmin
